import React from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';

import './index.css';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import './features/visuals/css/EventsSwiper.css';

import './features/theming/css/typography.css';
import './features/theming/css/layout.css';
import './features/theming/css/theme.css';
import './features/theming/css/distance.css';
import './features/theming/css/utils.css';

// import './features/theming/css/develop.css';

const root = createRoot(document.getElementById('root'));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
